import { render } from "./MonthlySpendingChart.vue?vue&type=template&id=1c82dbb3&ts=true"
import script from "./MonthlySpendingChart.vue?vue&type=script&lang=ts"
export * from "./MonthlySpendingChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__